import { Typography } from '@mui/material'
import type React from 'react'
import IndustryCardGrid from 'src/features/templateEdit/common/IndustryCardGrid'
import type { IndustryInfo } from 'src/features/templateEdit/onboardingDynamic/types'

interface OwnProps {
  showIndustries: IndustryInfo[][]
  onClick: (industry: IndustryInfo) => void
}

const ShowTemplateIndustryType: React.FC<OwnProps> = (props: OwnProps) => {
  return (
    <>
      <Typography
        variant="subtitle1"
        fontWeight="bold"
        textAlign="center"
        mt={8}
        mb={2}
      >
        テンプレートからつくる
      </Typography>
      <IndustryCardGrid
        showIndustries={props.showIndustries}
        onClick={props.onClick}
      />
    </>
  )
}

export default ShowTemplateIndustryType
